$(document).ready(function()
{

    $( ".stay-on-page-dropdown-menu a" ).click(function(e) 
    {
        e.preventDefault();
        var filterValue = $(this).data("filter-value");
        var text = $(this).text();
        $('#filterDropdown').html(text);
        applyDropdownFilters(filterValue);
    });


    function applyDropdownFilters(filterValue)
    {
        let active_ids = 0;

        // first hide them all
        $('.listings-group .col').each(function(i, obj)
        {
            $(this).fadeOut(300);
        });
        setTimeout( 
            function() 
            { 
                showActiveCards(filterValue);
            }, 300 
        );

        function showActiveCards(filterValue)
        {
            // return those inside the current limit
            $('.listings-group .col').each(function(i, obj)
            {
                showItem = 0;

                if(!filterValue || (filterValue && $(this).data('category').includes(filterValue) ) )
                {
                    showItem++;
                }
                if(showItem > 0)
                {
                    active_ids++
                    $(this).fadeIn(300); 
                }



            });
            //console.log(active_ids);
            $('#page-counter-results').text(active_ids + " item" + ( (active_ids != 1) ? "s" : ''  ));

            if (active_ids > 0)
            {
                $("#no-results").removeClass("active");                
            }
            else
            {
                $("#no-results").addClass("active");   
                //$("#listings-sort a").removeClass("active");
            }
        }

    }

});